import request from '@/utils/request'
import { cmsServerContext } from '@/config/config'

export function getCustomerRoles(condition) {
  return request({
    url: cmsServerContext + '/customerRole/list',
    method: 'post',
    data: condition
  })
}

export function saveCustomerRole(customerRole) {
  return request({
    url: cmsServerContext + '/customerRole/save',
    method: 'post',
    data: customerRole
  })
}

/**
 * 客户编号唯一性校验, 编号必填 编辑的需要加上id
 * Add by xingxiaowen on 2018/10/15
 * @param customerRole
 */
export function verifyCustomerRole(customerRole) {
  return request({
    url: cmsServerContext + '/customerRole/verify',
    method: 'post',
    data: customerRole
  })
}

export function selectRoleByCode(customerRole) {
  return request({
    url: cmsServerContext + '/customerRole/selectRoleByCode',
    method: 'post',
    data: customerRole
  })
}
